const lang = {
	en: {
		nav: {
			aboutUs: 'About Us',
			services: 'Services',
			helpAndFAQ: 'Help & FAQ',
			contactUs: 'Contact Us',
			language: 'Language',
			login: 'Login',
			myPage: 'My Profile',
		},
		header: {
			title: 'Flashcards for Education',
			startHereBtn: 'Start here',
		},
		services: {
			title: 'basic services we provide',
			flashCards: {
				title: 'Flash Cards',
				items: [
					'Create your own flash cards',
					'Automatically create flash cards',
					'Upload the materials',
					'Have your own card bag',
				],
			},
			selfTests: {
				title: 'Self-Tests',
				items: [
					'Customize your personal review schedule',
					'Choose different types of tests',
					'Can be downloaded',
					'Auto-save system tracks progress',
				],
			},
			whatElse: 'What else can we do?',
		},
		whyUs: {
			title: 'Why choose us?',
			subtitle: 'We creates the fastest, easiest, and best quality of translation',
			items: [
				{
					title: 'Light & Fast',
					desc: 'We translate minutes and you can get what you need.',
				},
				{
					title: 'High Quality',
					desc: 'Automated updates, firewall, reporting, and monitoring.',
				},
				{
					title: 'Easy to Setup',
					desc: 'Simplified personal home page and less complex function.',
				},
				{
					title: 'Free',
					desc: 'All the core features are FREE of cost and always will be.',
				},
			],
		},
	},
};

export default lang;
